import { render, staticRenderFns } from "./MemberGroup.vue?vue&type=template&id=4e4761f7&"
import script from "./MemberGroup.vue?vue&type=script&lang=js&"
export * from "./MemberGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports